import { render, staticRenderFns } from "./selectCategory.vue?vue&type=template&id=53b2ac84&scoped=true&"
import script from "./selectCategory.vue?vue&type=script&lang=js&"
export * from "./selectCategory.vue?vue&type=script&lang=js&"
import style0 from "./selectCategory.vue?vue&type=style&index=0&id=53b2ac84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b2ac84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VProgressLinear,VRow,VSheet,VTreeview})
